// Which cards the Warning Dashboard landing page starts with (the user's lists, 2026-10-08). The front-line teams with nobody under
// them see a short list; everyone else sees every card. The server says which list a person is on (GET warning-dashboard/my-view,
// my_view.controller.js); this file is the lists and the pure function that picks the cards. Cards are named by their `path`.
//
//   ogd = OGD people with nobody under them (OGA, OGO...)
//   cro = CROs of the project departments with nobody under them
//   all = everyone else - and anyone who turns on "Advanced"
// The order below is the order the cards appear in.
export const OGD_VIEW = [
  'lcr', 'acr', 'lta', 'sfr', 'tar', 'arpu', 'admission-count', 'new-lead-assignment-count', 'fee-collection', 'weekly-revenue',
  'sales-cycle-length', 'revenue-per-oga', 'lcrr', 'refunds',
];

export const CRO_VIEW = [
  'tar', 'arpu', 'fee-collection', 'mau', 'sales-count', 'acl', 'ccr', 'fdr', 'sar', 'atp', 'ats', 'refunds', 'tutor-count', 'tutor-replacement-count', 'tutor-replacement-by-tutor', 'fee-transfer-count',
];

const LISTS = { ogd: OGD_VIEW, cro: CRO_VIEW };

// `allCards` = every card in the full view's order ([{ path, ... }]). A list names its cards; a name with no card is skipped, so a
// renamed or removed metric can never break the page.
export const cardsForView = (view, allCards) => {
  const list = LISTS[view];
  if (!list) return allCards;
  const byPath = new Map(allCards.map((c) => [c.path, c]));
  return list.map((path) => byPath.get(path)).filter(Boolean);
};

// the short lists apply only to these views; 'all' people already see everything, so they get no Advanced switch
export const hasShortList = (view) => Boolean(LISTS[view]);

// What a person who sees every card by default (Finance, managers, other departments) can pick instead: the OGD set or the CRO set
// (the same two lists). Anything else - including a made-up value in the address - means "all".
export const LENSES = ['ogd', 'cro'];
export const lensFrom = (value) => (LENSES.includes(value) ? value : 'all');
